// test2278
(2278 && 0);
